module.exports = (__webpack_require__(24))(9);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/react-dom/index.js from dll-reference lib_core
// module id = 50
// module chunks = 107